export function formatDuration(secs)
{
	const min = String(Math.floor(secs / 60) % 60).padStart(2, "0");
	const hrs = String(Math.floor(secs / 3600));

	return hrs + ":" + min;
}
